import { z } from "zod";

const translationPath = "page.settings.crm.ticketAutoFinishRules.errors.";

const ticketTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "ticket_type" }
);

const ticketChannelStepSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  {
    invalid_type_error: translationPath + "ticket_channel_step",
    required_error: translationPath + "ticket_channel_step",
  }
);

const ticketChannelStepTransferSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  {
    invalid_type_error: translationPath + "ticket_channel_step_transfer",
    required_error: translationPath + "ticket_channel_step_transfer",
  }
);

const ticketChannelSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "ticket_channel" }
);

const ticketWorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().optional().nullable(),
});

export const ticketAutoFinishRuleSchema = z
  .object({
    id: z.string().optional(),
    finish: z.boolean(),
    ticketType: ticketTypeSchema,
    ticketChannelStep: ticketChannelStepSchema.nullable(),
    ticketChannelStepTransfer: ticketChannelStepTransferSchema.nullable(),
    ticketChannel: ticketChannelSchema
      .nullable()
      .refine((val) => val, translationPath + "ticket_channel"),
    ticketChannelTransfer: ticketChannelSchema.nullable(),
    ticketWorkspace: ticketWorkspaceSchema
      .optional()
      .nullable()
      .refine((val) => val, translationPath + "ticket_workspace"),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    minutes: z.string().optional(),
    message: z.string().optional(),
    endOfDay: z.boolean(),
    finishIndifferentPerson: z.boolean(),
  })
  .superRefine((val, ctx) => {
    if (val.finish) {
      if (!val.message || val.message.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["message"],
          message: translationPath + "message",
        });
      }
      if (!val.minutes || val.minutes.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["minutes"],
          message: translationPath + "minutes",
        });
      } else if (Number(val.minutes) > 1440) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["minutes"],
          message: translationPath + "max_minutes",
        });
      }
    }
    if (val.endDate < val.initialDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TTicketAutoFinishRuleForm = z.infer<
  typeof ticketAutoFinishRuleSchema
>;
